import { JsonClassType, JsonProperty, ObjectMapper, JsonIgnore } from "@outfoxx/jackson-js";
import { JsonParserContext } from "@outfoxx/jackson-js/dist/@types";
import { Geometry } from "modules/construction-work/src/Entity/Work/Geometry";
import { Properties } from "modules/construction-work/src/Entity/Work/Properties";

export class IncidentMap {
    @JsonProperty()
    @JsonClassType({ type: () => [Geometry] })
    geometry: Geometry;
    @JsonProperty()
    @JsonClassType({ type: () => [Properties] })
    properties: Properties;
    @JsonProperty()
    type: string;

    public static createByObj(object): IncidentMap {
        if (!object) {
            throw new Error();
        }

        const objectMapper = new ObjectMapper();
        const context = { mainCreator: () => [IncidentMap] } as JsonParserContext;

        return objectMapper.parse<IncidentMap>(JSON.stringify(object), context);
    }
}